<script>
import InputOtp from "primevue/inputotp";
import { ref } from "vue";

const value = ref(null);

export default {
  components: {
    InputOtp,
  },
  data() {
    return {
      value,
    };
  },
  methods: {
    submitForm() {
      this.$router.push("/otp-email");
    },
  },
};
</script>
<template>
  <div class="authentication-page">
    <div class="d-flex justify-content-between vh-100 overflow-auto flex-column">
      <!-- Header -->
      <div class="authentication-header">
        <div class="container">
          <div class="col-md-12">
            <div class="text-center">
              <img src="@/assets/img/logo.svg" alt="logo" />
            </div>
          </div>
        </div>
      </div>
      <!-- /Header -->

      <!-- Main Wrapper -->
      <div class="main-wrapper">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-5 mx-auto">
              <form @submit.prevent="submitForm" class="digit-group">
                <div class="d-flex flex-column justify-content-center">
                  <div class="card p-sm-4">
                    <div class="card-body">
                      <div class="text-center mb-3">
                        <h3 class="mb-2">Phone OTP Verification</h3>
                        <p>OTP sent to your mobile number ending******9575</p>
                      </div>
                      <div class="text-center otp-input">
                        <div class="d-flex align-items-center mb-3">
                          <InputOtp v-model="value" />
                        </div>
                        <div>
                          <div class="badge bg-danger-transparent mb-3">
                            <p class="d-flex align-items-center">
                              <i class="ti ti-clock me-1"></i>09:59
                            </p>
                          </div>
                          <div class="mb-3 d-flex justify-content-center">
                            <p>
                              Didn't get the OTP?
                              <a href="javascript:void(0);" class="text-primary"
                                >Resend OTP</a
                              >
                            </p>
                          </div>
                          <div>
                            <button
                              type="submit"
                              class="btn btn-lg btn-linear-primary w-100"
                            >
                              Verify & Proceed
                            </button>
                          </div>
                        </div>
                      </div>
                      <div>
                        <img
                          src="@/assets/img/bg/authentication-bg.png"
                          class="bg-left-top"
                          alt="Img"
                        />
                        <img
                          src="@/assets/img/bg/authentication-bg.png"
                          class="bg-right-bottom"
                          alt="Img"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- /Main Wrapper -->

      <!-- Footer -->
      <div class="footer-copyright bg-transparent">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <p>Copyright &copy; 2024. All Rights Reserved Truelysell</p>
            </div>
          </div>
        </div>
      </div>
      <!-- /Footer -->
    </div>

    <div class="back-to-top">
      <a
        class="back-to-top-icon align-items-center justify-content-center d-flex"
        href="#top"
        ><i class="fa-solid fa-arrow-up"></i
      ></a>
    </div>

    <!-- Cursor -->
    <div class="xb-cursor tx-js-cursor">
      <div class="xb-cursor-wrapper">
        <div class="xb-cursor--follower xb-js-follower"></div>
      </div>
    </div>
    <!-- /Cursor -->
  </div>
</template>
